const toggleSwitch = document.querySelectorAll(
  ".product-info__toggle"
) as NodeList | null;
const qtyButtons = document.querySelectorAll(
  ".summary__single-product-button"
) as NodeList | null;
const cartButton = document.getElementById("addToCart") as HTMLButtonElement;
const qtyElements = document.querySelectorAll(
  ".summary__single-product-qty-input"
) as NodeListOf<HTMLInputElement>;
const summaryWrap = document.querySelector(
  ".summary__multi-product-wrap"
) as HTMLElement;
const minAmount = document.getElementById("minAmount") as HTMLParagraphElement;
const sumTotalWrap = document.getElementById("sumTotalWrap") as HTMLDivElement;
const sumTotalWrapLocale = sumTotalWrap ? sumTotalWrap.getAttribute("data-locale") : 'sl';
const sumTotalNumber = document.querySelector(
  ".summary__total span"
) as HTMLSpanElement;
const sumTotal = document.getElementById("sumTotal") as HTMLParagraphElement;
const sumBottlesWrap = document.getElementById(
  "sumBottlesWrap"
) as HTMLDivElement;
const sumPacketsNumber = document.getElementById(
  "sumPacketsNumber"
) as HTMLSpanElement;
const sumBottlesNumber = document.getElementById(
  "sumBottlesNumber"
) as HTMLSpanElement;
const packetsPlural = document.getElementById(
  "packetsPlural"
) as HTMLSpanElement;
const messageSuccess = document.getElementById(
  "messageSuccess"
) as HTMLDivElement;
const messageFail = document.getElementById("messageFail") as HTMLDivElement;
let totalPackets: number = 0;
let packPrice = sumTotalWrapLocale == 'de' ? 27.96 : 23.96;
let bottlePrice = sumTotalWrapLocale == 'de' ? 6.99 : 5.99;
let kgPrice = sumTotalWrapLocale == 'de' ? 19.19 : 15.36;

//Product details toggle
if (toggleSwitch) {
  toggleSwitch.forEach((element) => {
    element.addEventListener("click", (e) => {
      (element as HTMLElement).classList.toggle("true");
    });
  });
}

//Quantity buttons
if (qtyButtons && cartButton) {
  Array.from(qtyButtons).forEach((btn) => {
    btn.addEventListener("click", (e) => {
      if (e.target) {
        let productId = (e.target as HTMLElement).getAttribute(
          "data-product-id"
        ) as String;
        let buttonType = (e.target as HTMLElement).getAttribute(
          "data-type"
        ) as String;
        let qtyInput = document.querySelector(
          `.summary__single-product-qty-input[data-product-id='${productId}'`
        ) as HTMLInputElement;
        let qtySpan = document.querySelector(
          `.summary__single-product-qty[data-product-id='${productId}'`
        ) as HTMLSpanElement;

        if (buttonType === "sub") {
          qtyInput.stepDown(1);
        } else if (buttonType === "add") {
          qtyInput.stepUp(1);
        }

        sumTotalWrap.style.display = "flex";
        messageSuccess.style.display = "none";
        messageFail.style.display = "none";

        qtySpan.innerHTML = qtyInput.value;
        calculateTotalSelectedPackets();

        if (totalPackets > 0) {
          cartButton.classList.remove("disabled");
          minAmount.style.display = "none";
          sumTotal.style.display = "block";
          sumBottlesWrap.style.display = "block";

          let totalPrice = totalPackets * packPrice;

          // Comment out, to disable discount display and calculation
          applyBulkDiscount(totalPrice, totalPackets);

          sumPacketsNumber.textContent = totalPackets.toString();
          sumBottlesNumber.textContent = (totalPackets * 4).toString();
          sumTotalNumber.textContent = totalPrice.toLocaleString('sl', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          });
        } else {
          cartButton.classList.add("disabled");
          minAmount.style.display = "block";
          sumTotal.style.display = "none";
          sumBottlesWrap.style.display = "none";
          resetBulkDiscount();
        }

        if(sumTotalWrapLocale === 'de') {
          switch (totalPackets) {
            case 0:
              packetsPlural.textContent = "";
              break;
            case 1:
              packetsPlural.textContent = "";
              break;
            default:
              packetsPlural.textContent = "e";
              break;
          }
        } else {
          //Handle plurar for "Packets"
          switch (totalPackets) {
            case 0:
              packetsPlural.textContent = "";
              break;
            case 1:
              packetsPlural.textContent = "";
              break;
            case 2:
              packetsPlural.textContent = "a";
              break;
            case 3:
              packetsPlural.textContent = "i";
              break;
            case 4:
              packetsPlural.textContent = "i";
              break;
            case 5:
              packetsPlural.textContent = "ov";
              break;
            default:
              packetsPlural.textContent = "ov";
              break;
          }
        }
      }
    });
  });
}

//Cart button
if (cartButton) {
cartButton.addEventListener("click", (e) => {
  e.preventDefault();
  cartButton.classList.add("loading");
  summaryWrap.classList.add("disabled");

  let selectedItemsArray: Array<Object> = new Array();

  if (qtyElements) {
    qtyElements.forEach((e) => {
      let qty = e.value;
      let id = e.getAttribute("data-product-id");

      if (qty && id) {
        selectedItemsArray.push({
          id: +id,
          qty: +qty,
        });
      }
    });

    const ajaxData = (window as any).njamito_ajax;

    if ((window as any).njamito_ajax) {
      let data = new FormData();
      data.append("action", "njamito_add_to_cart");
      data.append("selectedItemsArray", JSON.stringify(selectedItemsArray));
      data.append("nonce", ajaxData.nonce);

      fetch(ajaxData.ajax_url, {
        method: "POST",
        body: data,
      })
        .then((response) => {
          return response.json();
        })
        .then((jsonResponse) => {
          sumTotalWrap.style.display = "none";
          if (!jsonResponse.success) {
            messageFail.style.display = "block";
          }

          if (jsonResponse.success) {
            //resetQuantities();
            //messageSuccess.style.display = "block";
            window.location.href = cartButton.getAttribute("data-href") || "/cart";
          }
          cartButton.classList.remove("loading");
          cartButton.classList.add("disabled");
          summaryWrap.classList.remove("disabled");
        });
    }
  }
});
}

//Calculate total number of selected packets
function calculateTotalSelectedPackets() {
  if (qtyElements) {
    totalPackets = 0;
    qtyElements.forEach((e) => {
      totalPackets += +e.value;
    });
    return totalPackets;
  }
}

//Resets all quantities back to zero
function resetQuantities() {
  qtyElements.forEach((e) => {
    let productId = e.getAttribute("data-product-id");
    let qtySpan = document.querySelector(
      `.summary__single-product-qty[data-product-id='${productId}'`
    ) as HTMLSpanElement;
    if (productId && qtySpan) {
      e.value = "0";
      qtySpan.innerHTML = "0";
    }
  });
}


// Bulk discount

const sumTotalWithDiscount = document.querySelector(".summary__total-with-discounted") as HTMLElement;
const sumTotalWithDiscountNumber = document.querySelector(".summary__total-with-discounted span") as HTMLElement;
const perBottlePrice = document.getElementById("perBottlePrice") as HTMLElement;
const perBottlePriceDiscounted = document.getElementById("perBottlePriceDiscounted") as HTMLElement;
const perKgPrice = document.getElementById("perKgPrice") as HTMLElement;
const perKgPriceDiscounted = document.getElementById("perKgPriceDiscounted") as HTMLElement;
const bulk5Description = document.getElementById("bulk-discount-5-applied") as HTMLElement;
const bulk10Description = document.getElementById("bulk-discount-10-applied") as HTMLElement;
const bulk15Description = document.getElementById("bulk-discount-15-applied") as HTMLElement;

function resetBulkDiscount() {
  if(sumTotalWithDiscount === null) return; // Discount rule is not enabled
  sumTotalWithDiscount.style.display = "none";
  perBottlePriceDiscounted.style.display = "none";
  perKgPriceDiscounted.style.display = "none";
  bulk5Description.classList.add('hidden');
  bulk10Description.classList.add('hidden');
  bulk15Description.classList.add('hidden');
}

function applyBulkDiscount(totalPrice, totalPackets) {
  // discount is applicable only for Slovenian locale
  if (sumTotalWrapLocale !== 'sl') {
    return;
  }

  if(sumTotalWithDiscount === null) return; // Discount rule is not enabled

  // Return 0 to disable discount.
  let discount = 0;

  let perBottlePriceValue = perBottlePrice.dataset.price ? parseFloat(perBottlePrice.dataset.price) : bottlePrice;
  let perKgPriceValue = perKgPrice.dataset.price ? parseFloat(perKgPrice.dataset.price) : kgPrice;

  if (totalPackets === 1) {
    discount = 5;
    bulk5Description.classList.remove('hidden');
    bulk10Description.classList.add('hidden');
    bulk15Description.classList.add('hidden');
    perKgPriceDiscounted.textContent = (perKgPriceValue - ((perKgPriceValue / 100) * discount)).toLocaleString('sl', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  if (totalPackets === 2) {
    discount = 10;
    bulk5Description.classList.add('hidden');
    bulk10Description.classList.remove('hidden');
    bulk15Description.classList.add('hidden');
    perKgPriceDiscounted.textContent = (perKgPriceValue - ((perKgPriceValue / 100) * discount)).toLocaleString('sl', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }
  if (totalPackets >= 3) {
    discount = 15;
    bulk5Description.classList.add('hidden');
    bulk10Description.classList.add('hidden');
    bulk15Description.classList.remove('hidden');
    perKgPriceDiscounted.textContent = (perKgPriceValue - ((perKgPriceValue / 100) * discount)).toLocaleString('sl', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  perBottlePriceDiscounted.textContent = (perBottlePriceValue - ((perBottlePriceValue / 100) * discount)).toLocaleString('sl', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  let totalWithDiscountPrice = totalPrice - ((totalPrice / 100) * discount);

  if(totalWithDiscountPrice > 0 && totalPrice !== totalWithDiscountPrice) {
    sumTotalWithDiscountNumber.textContent = totalWithDiscountPrice.toLocaleString('sl', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    sumTotalWrap.classList.add("discounted");
    sumTotalWithDiscount.style.display = "block";
    perBottlePriceDiscounted.style.display = "inline";
    perKgPriceDiscounted.style.display = "inline";
  }
}